import React from 'react';
import { Truck, Wrench, Phone } from 'lucide-react';
export function TopBar() {
  return <div className="bg-brand-green text-white py-2 px-4 text-sm font-medium" data-id="element-465">
      <div className="max-w-7xl mx-auto flex justify-center items-center text-center" data-id="element-466">
        {/* Mobile View */}
        <div className="md:hidden flex items-center justify-center gap-3 space-x-2" data-id="element-467">
          <span className="flex items-center gap-1.5" data-id="element-468">
            <Truck size={14} data-id="element-469" /> Nationwide shipping
          </span>
          <span className="opacity-50" data-id="element-470">•</span>
          <a href="tel:301-620-7585" className="flex items-center gap-1.5 hover:text-brand-gold transition-colors" data-id="element-471">
            <Phone size={14} data-id="element-472" /> Call 301-620-7585
          </a>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex items-center justify-center gap-4" data-id="element-473">
          <span className="flex items-center gap-1.5" data-id="element-474">
            <Truck size={16} data-id="element-475" /> Nationwide shipping
          </span>
          <span className="opacity-50" data-id="element-476">•</span>
          <span className="flex items-center gap-1.5" data-id="element-477">
            <Wrench size={16} data-id="element-478" /> Installation available in select Mid-Atlantic
            areas
          </span>
          <span className="opacity-50" data-id="element-479">•</span>
          <a href="tel:301-620-7585" className="flex items-center gap-1.5 hover:text-brand-gold transition-colors" data-id="element-480">
            <Phone size={16} data-id="element-481" /> Call 301-620-7585
          </a>
        </div>
      </div>
    </div>;
}